<template>
	<div class="all-wrap">
		<!-- 微信分享卡片(标题=作品名，描述=作品描述，首图=客户 logo) -->
		<ShareMeta :title="shareTitle" :description="shareDesc" :image="brandLogo" />

		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>
		<!-- 左侧悬浮板块导航 -->
		<SectionNav active="works" />

		<!-- 顶部 banner 区(站内框架,高度紧凑) -->
		<div class="videolist-banner">
			<Headernew />
			<div class="bannertop-title">
				<div>作品详情</div>
				<div>——后天科技·项目作品</div>
			</div>
		</div>

		<!-- 主体 -->
		<div class="app-container">
			<BackButton v-if="isVip" @click="goList" />

			<LoadingBlock v-if="loading" />

			<template v-else>

			<!-- 版块标签：点击滚动跳转 -->
			<div class="section-tabs" v-if="detail">
				<button class="section-tab" @click="scrollToSection('sec-info')">基本信息</button>
				<button class="section-tab" v-if="detail.content" @click="scrollToSection('sec-content')">描述</button>
				<button class="section-tab" v-if="detail.video_url" @click="scrollToSection('sec-video')">视频</button>
				<button class="section-tab" v-if="detail.image_url" @click="scrollToSection('sec-image')">图片</button>
				<button class="section-tab" v-if="detail.text_intro" @click="scrollToSection('sec-text')">文字说明</button>
			</div>

			<div v-if="detail" class="detail-card" id="sec-info">
				<div class="detail-title"><i class="iconfont icon-shipinbofangyingpian"></i> {{ detail.main }}</div>

				<div class="field" v-if="detail.keys_name"><span class="label">标签</span><span class="value">{{ detail.keys_name }}</span></div>
				<div class="field" v-if="detail.created_at"><span class="label">创建时间</span><span class="value">{{ detail.created_at }}</span></div>
				<div class="field" v-if="detail.link_url"><span class="label">外链</span><span class="value"><a v-if="isUrl(detail.link_url)" :href="detail.link_url" target="_blank" rel="noopener noreferrer">{{ detail.link_url }}</a><span v-else>{{ detail.link_url }}</span></span></div>
			</div>
			<div v-else class="empty-state"><i class="iconfont icon-dengdai"></i><p>{{ loadError || '未找到该作品' }}</p></div>

			<!-- 媒体预览：分版块，有哪个显示哪个(描述在最前) -->
			<div class="media-block" v-if="detail">
				<div class="section-card" v-if="detail.content" id="sec-content">
					<div class="section-title"><i class="iconfont icon-dianying"></i> 描述</div>
					<div class="content-block" v-html="detail.content"></div>
				</div>
				<div class="section-card" v-if="detail.video_url" id="sec-video">
					<div class="section-title"><i class="iconfont icon-shipinbofangyingpian"></i> 视频版块</div>
					<!-- 微信兼容：对齐项目内已验证可播的最简内联写法（不使用实验性的 x5-video-player-type） -->
					<video ref="videoEl" controls="controls" playsinline="playsinline" webkit-playsinline="true"
						x5-playsinline="true" preload="metadata" controlslist="nodownload"
						:src="detail.video_url" :poster="detail.image_url || ''"
						style="width:100%;max-height:70vh;border-radius:8px;background:#000;"
						@error="onVideoError"></video>
					<div v-if="videoError" class="video-error">
						<span>当前浏览器无法直接播放，可</span>
						<a :href="detail.video_url" target="_blank" rel="noopener noreferrer">在浏览器中打开</a>
					</div>
				</div>
				<div class="section-card" v-if="detail.image_url" id="sec-image">
					<div class="section-title"><i class="iconfont icon-dianying"></i> 图片版块</div>
					<img :src="detail.image_url" style="width:100%;border-radius:8px;display:block;">
				</div>
				<div class="section-card" v-if="detail.text_intro" id="sec-text">
					<div class="section-title"><i class="iconfont icon-dianying"></i> 文字说明</div>
					<div class="text-block">{{ detail.text_intro }}</div>
				</div>
			</div>

			</template>
		</div>

		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'
import SectionNav from '@/components/SectionNav.vue'
import BackButton from '@/components/BackButton.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import ShareMeta from '@/components/ShareMeta.vue'

export default {
	name: 'workDetail',
	components: { Headernew, Footernew, Comment, gotop, SectionNav, BackButton, LoadingBlock, ShareMeta },
	data() {
		return { detail: null, videoError: false, loadError: '', loading: false, brandName: '', brandLogo: '' }
	},
	created() {
		this.load()
	},
	computed: {
		// 微信分享标题/描述(描述优先用作品描述，去掉标签后截断)
		shareTitle() { return (this.detail && this.detail.main) || '后天科技 · 项目作品' },
		shareDesc() {
			const text = this.plainText(this.detail && this.detail.content, 40)
			if (text) return text
			return (this.brandName ? this.brandName + '的作品' : '项目作品') + ' · 后天科技'
		},
		// 是否 VIP：与 Headernew 一致，取缓存 usermessage.adminid == 1
		isVip() {
			try {
				const m = localStorage.getItem('usermessage')
				if (!m) return false
				return JSON.parse(m).adminid == 1
			} catch (e) {
				return false
			}
		},
	},
	methods: {
		load() {
			this.loading = true
			this.$axios.get(this.$api + '/getWorksCaseById/' + this.$route.query.id)
				.then(res => {
					const body = res.data || {}
						if (body.success && body.result) {
							this.detail = body.result
							this.loadError = ''
							this.loadBrand()
						} else {
							// 接口以 success:false 返回(如"相关方案已过期")，把 message 提示给用户
							this.detail = null
							this.loadError = body.message || ''
						}
					// 安卓 X5 内核对异步绑定 src 的 video 有时不自动加载，手动 load 一次
					if (this.detail && this.detail.video_url) {
						this.$nextTick(() => { if (this.$refs.videoEl) this.$refs.videoEl.load() })
					}
				})
				.catch(err => {
					console.log(err)
					this.detail = null
					this.loadError = '加载失败，请稍后重试'
				})
				.finally(() => { this.loading = false })
		},
		// 拉取当前客户(取名称做分享描述、logo 做分享缩略图)
		loadBrand() {
			const bid = this.$route.query.brand_id || (this.detail && this.detail.brand_id)
			if (!bid) return
			this.$axios.get(this.$api + '/getBrand', {
				params: { page: 1, limit: 1000 }
			}).then(res => {
				const list = (res.data.result && res.data.result.data) || []
				const cur = list.find(b => String(b.id) === String(bid))
				if (cur) {
					this.brandName = cur.name
					this.brandLogo = cur.logo_url || ''
				}
			}).catch(err => console.log(err))
		},
		// 去掉 HTML 标签并截断，用于分享描述
		plainText(v, len) {
			const s = String(v || '').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
			return s.length > len ? s.slice(0, len) + '…' : s
		},
		// 是否为可跳转的 http(s) 链接(非 URL 的外链只作文本展示，避免点出无效地址)
		isUrl(v) {
			return /^https?:\/\//i.test(String(v || '').trim())
		},
		// 全部作品：回到该客户(brand_id)的作品时间轴；无 brand_id 时回列表页
		goList() {
			// 客户 id 优先取路径参数(从列表页带过来)，其次取详情接口返回
			const bid = this.$route.query.brand_id || (this.detail && this.detail.brand_id)
			if (bid) {
				this.$router.push({ path: '/brandProposal', query: { brand_id: bid, tab: 'works' } })
			} else {
				this.$router.push({ path: '/projectProposal', query: { tab: 'works' } })
			}
		},
		onVideoError() { this.videoError = true },
		scrollToSection(id) {
			const el = document.getElementById(id)
			if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
		},
	},
}
</script>

<style scoped>
.videolist-banner { width: 100%; height: 300px; background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg); background-size: 100% 100%; position: relative; }
.bannertop-title { width: 100%; position: absolute; left: 0; top: 45%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 38px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 14px auto 0; font-size: 18px; color: #fff; text-align: right; letter-spacing: 2px; }

.app-container { max-width: 900px; margin: 0 auto; padding: 2rem 1.5rem 4rem; text-align: left; }

.detail-card { box-sizing: border-box; max-width: 1100px; margin: 0 auto; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 4px 12px rgba(0,0,0,.04); }
.detail-card .field { display: flex; padding: .6rem 0; border-bottom: 1px solid #f1f5f9; }
.detail-card .field:last-child { border-bottom: none; }
.detail-card .field .label { width: 90px; font-weight: 500; color: #64748b; flex-shrink: 0; font-size: .9rem; }
.detail-card .field .value { flex: 1; color: #0a2540; font-size: .95rem; word-break: break-word; }
.detail-title { font-size: 1.5rem; font-weight: 600; color: #0a2540; margin-bottom: 1rem; display: flex; align-items: center; gap: .5rem; }
.detail-title i { color: #2563eb; }
.value a { color: #2563eb; text-decoration: underline; word-break: break-all; }

.media-block { max-width: 1100px; margin: 1.5rem auto 0; display: flex; flex-direction: column; gap: 1rem; }
.video-error { margin-top: .5rem; font-size: .85rem; color: #94a3b8; }
.video-error a { color: #2563eb; text-decoration: underline; }
.section-card { box-sizing: border-box; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 2px 8px rgba(0,0,0,.03); }
.section-title { font-size: .95rem; font-weight: 600; color: #0a2540; margin-bottom: .75rem; display: flex; align-items: center; gap: .4rem; }
.section-title i { color: #2563eb; }
.content-block { line-height: 1.7; word-break: break-word; }
.text-block { white-space: pre-wrap; color: #475569; }

/* 版块标签条 */
.section-tabs { max-width: 1100px; margin: .5rem auto 1rem; display: flex; flex-wrap: wrap; gap: .5rem; }
.section-tab { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; padding: .35rem .9rem; border-radius: 20px; font-size: .85rem; cursor: pointer; transition: all .15s; }
.section-tab:hover { background: #dbeafe; color: #2563eb; border-color: #2563eb; }
.detail-card, .section-card { scroll-margin-top: 90px; }

.rel-item { display: flex; align-items: center; justify-content: space-between; padding: .6rem 1rem; background: #fafcff; border-radius: 10px; border: 1px solid #eef2f6; margin-bottom: .5rem; }
.btn-link { background: #2563eb; color: #fff; border: none; padding: .4rem 1rem; border-radius: 30px; font-weight: 500; font-size: .85rem; cursor: pointer; display: inline-flex; align-items: center; gap: .3rem; transition: background .2s; }
.btn-link:hover { background: #1d4ed8; }

.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }

@media (max-width: 768px) {
	.videolist-banner { height: 220px; }
	.bannertop-title { top: 48%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	.detail-card { padding: 1rem; }
	.detail-card .field { flex-direction: column; gap: .2rem; }
	.detail-card .field .label { width: auto; }
}
</style>

<style>
@import '../../assets/css/alibaba.css';
</style>